__turbopack_context__.v({
  "badge": "sectionHeader-module-scss-module__Lrg9jq__badge",
  "header": "sectionHeader-module-scss-module__Lrg9jq__header",
  "isActive": "sectionHeader-module-scss-module__Lrg9jq__isActive",
  "label": "sectionHeader-module-scss-module__Lrg9jq__label",
  "labelText": "sectionHeader-module-scss-module__Lrg9jq__labelText",
  "noLink": "sectionHeader-module-scss-module__Lrg9jq__noLink",
});
